export default __webpack_public_path__ + "static/media/credit-card__2_.502af406.png";